<div [ngClass]= "'panel ' + color">
    <div class="panel-heading">
        <h5 style="display: inline-block">
            <span>Parent Companies </span>
            <span class="badge badge-info">{{ companies.length }}</span>
        </h5>
        <div class="btn-toolbar pull-right">
            <div class="btn-group btn-group-md" *ngIf="!live">
                <button type="button" class="btn btn-primary" title="Add Company" (click)="addCompany()">
                    <span data-toggle="tooltip" class="fa fa-plus-square fa-lg"></span>
                </button>
            </div>
            <div class="btn-group btn-group-md">
                <company-filter [live]="live"></company-filter>
            </div>
        </div>
    </div>
    <div class="panel-body panel-list">
        <div *ngIf="processing" class="list-group" style="overflow-y:scroll; max-height: 600px;">
            <i class="fa fa-spinner fa-spin"></i> Loading Companies...
        </div>
        <div class="panel-group" style="height:370px" *ngIf="companies">
            <company-entity [live]="live" [company]="company" *ngFor="let company of companies"></company-entity>
        </div>
    </div>
</div>

<div bsModal #companyModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width: 1000px;">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                <h3 class="modal-title" id="myModalLabel"><span>{{ company.Name }}</span><span> &bull; Details</span></h3>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <span>Date Last Modified </span>
                        <i class="fa fa-ellipsis-v"></i>
                        <span> {{ company.LastModified | amDateFormat: 'MM/DD/YYYY' }} at {{ company.LastModified | amDateFormat: 'hh:mm A' }}</span>
                    </div>
                    <div class="col-lg-6">
                        <div class="pull-right">
                            <span>Status </span>
                            <i class="fa fa-ellipsis-v"></i>
                            <span> {{ company.Active ? 'Active' : 'Inactive' }}</span>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Mine Sites</span>
                                    <span class="pull-right badge">{{ minesites.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <table style="width: 100%">
                                    <colgroup>
                                        <col style="width: 50%" />
                                        <col style="width: 50%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Minesite</th>
                                            <th>Equipment Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let minesite of minesites">
                                            <td>{{ minesite.Name }}</td>
                                            <td>{{ minesite.Equipment?.Data?.length }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Equipment</span>
                                    <span class="pull-right badge">{{ equipment.Data.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;" *ngIf="equipment.Data">
                                <table style="width: 100%">
                                    <colgroup>
                                        <col style="width: 50%" />
                                        <col style="width: 50%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Serial Number</th>
                                            <th>Location</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let equipment of equipment.Data">
                                            <td>
                                                {{ equipment.Serial }} ({{ equipment.Model.Name }} {{equipment.PoweredBy.Name }})
                                            </td>
                                            <td>{{ equipment.Minesite.Name }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row" *ngIf="displayWarning">
                    <div class="col-sm-12 alert alert-warning" style="text-align:center" role="alert" >
                        No users selected!
                    </div>
                </div>
                <div class="row">
                    <div class="dual-list list-left col-md-5">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <span class="badge">{{ companyUsers.length }}</span>
                                <span>Associated Accounts</span>
                                <div class="pull-right btn-group btn-group-md" *ngIf="!live">
                                    <a class="btn btn-info" title="Select All" style="padding:4px 8px; font-size: 10px;" (click)="selectAllCompanyUsers()">
                                        <span data-toggle="tooltip" class="fa fa-check-square-o"></span>
                                    </a>
                                </div>
                            </div>
                            <div class="well text-right" style="padding:4px; margin-bottom: 2px; font-size: 10px;">
                                <ul class="list-group" style="height: 190px; overflow-y: scroll; padding:2px; margin-bottom: 2px;">
                                    <li class="list-group-item" [class.list-group-item-success]="user.Selected" *ngFor="let user of companyUsers" (click)="selectUser(user)"><span>{{ user.FirstName }} {{ user.LastName }} ({{ user.UserName }})</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="list-arrows col-md-1 text-center" *ngIf="!live">
                        <button class="btn btn-default btn-sm move-left" (click)="addCompanyUsers()">
                            <span class="glyphicon glyphicon-chevron-left"></span>
                        </button>
                        <button class="btn btn-default btn-sm move-right" (click)="removeCompanyUsers()">
                            <span class="glyphicon glyphicon-chevron-right"></span>
                        </button>
                    </div>
                    <div class="dual-list list-right col-md-5">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <span class="badge">{{ availableUsers.length }}</span>
                                <span>Available Accounts</span>
                                <div class="pull-right btn-group btn-group-md" *ngIf="!live">
                                    <a class="btn btn-info" title="Select All" style="padding:4px 8px; font-size: 10px;" (click)="selectAllAvailableUsers()">
                                        <span data-toggle="tooltip" class="fa fa-check-square-o" ></span>
                                    </a>
                                </div>
                            </div>
                            <div class="well" style="padding:4px; margin-bottom: 2px; font-size: 10px;">
                                <ul class="list-group" style="height: 190px; overflow-y: scroll; padding:2px; margin-bottom: 2px;">
                                    <li class="list-group-item" [class.list-group-item-success]="user.Selected" *ngFor="let user of availableUsers" (click)="selectUser(user)"><span>{{ user.FirstName }} {{ user.LastName }} ({{ user.UserName }})</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!live" bsModal #createCompanyModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="create()">
                <div class="modal-header">
                    <button type="button" class="close" aria-hidden="true" (click)="cancelAdd()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">{{ add ? 'Create Company' : 'Edit Company &bull;' + company.Name }}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon" for="CompanyName">Company Name</label>
                                <input id="CompanyName" name="CompanyName" type="text" class="form-control" placeholder="Company Name" [(ngModel)]="company.Name" />
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="!add">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon">Status</label>
                                <div class="btn-group btn-group-justified">
                                    <label class="btn" [class.btn-info]="company.Active" [class.btn-warning]="!company.Active" (click)="company.Active = !company.Active">
                                        <span>{{ company.Active ? 'Active' : 'Inactive' }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="!add">
                        <div class="col-md-9">
                            <input id="logoToUpload" name="logoToUpload" class="form-control form-control-static" placeholder="Choose File" disabled="disabled" [(ngModel)]="filename" />
                        </div>
                        <div class="col-md-2">
                            <div class="fileUpload btn btn-info">
                                <span>Choose File</span>
                                <input id="uploadLogoButton" class="upload" type="file" accept="image/*" (change)="preUpload($event)" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" *ngIf="add" class="pull-left btn btn-default" (click)="create(true)">Create and Add Another</button>
                    <button type="button" class="btn btn-default" (click)="cancelAdd()">Close</button>
                    <button type="submit" class="btn btn-primary">{{ add ? 'Create' : 'Save' }}</button>
                </div>
            </form>
        </div>
    </div>
</div>
